export class EntidadDto{
    public idEntidad :number = 0;
    public idTipoEntidad :number = 0;
}